import SolicitacoesDelecaoIndexPage from "@/Pages/SolicitacoesDelecao/index.vue";

export default [
  {
    path: "/solicitacoes-delecao/",
    name: "solicitacoes-delecao",
    component: SolicitacoesDelecaoIndexPage,
  },
];
